import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import StyledTableCell from "../../StyledTable/StyledTableCell/StyledTableCell";
import StyledTableRow from "../../StyledTable/StyledTableRow/StyledTableRow";
import SubmittedComchecksTableRow from "../SubmittedComchecksTableRow/SubmittedComchecksTableRow";
import { formatCurrency } from "../../../../../../utils/formatHelpers";
import { getSumOfArrayOfObjects } from "../../../../../../utils/calcHelpers";

export default function SubmittedComchecksTable({
  activeLoad, 
  stagedComchecksArray, 
  setStagedComchecksArray,
  setComcheckToEdit,
  setStep,
  handleDeleteStagedComcheck
}) {
  const [totalSum, setTotalSum] = useState("");

  useEffect(() => {
    const requestedAmounts = getSumOfArrayOfObjects(stagedComchecksArray, "requestedAmount");
    const fees = getSumOfArrayOfObjects(stagedComchecksArray, "comcheckFee");
    setTotalSum(requestedAmounts - fees);

  }, [stagedComchecksArray]);

  return (
    <Box>
      <Typography variant="body1" color="primary.60">
        COMCHECKS FOR LOAD #{activeLoad.id}
      </Typography>
      <TableContainer sx={{ borderRadius: "8px", marginTop: "10px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "black_solid.20" }}>
            <StyledTableRow>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Reason
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Express Code
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Total
                </Typography>
              </StyledTableCell>
              <StyledTableCell />
            </StyledTableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: "black_solid.10" }}>
            {stagedComchecksArray.map((row, i) => (
              <SubmittedComchecksTableRow 
                key={`submitted-comcheck-row-${i}`}
                row={row}
                setComcheckToEdit={setComcheckToEdit}
                setStep={setStep}
                handleDeleteStagedComcheck={handleDeleteStagedComcheck}
                setStagedComchecksArray={setStagedComchecksArray}
              />
            ))}
            <StyledTableRow>
              <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                <Typography variant="subhead2" color="black_solid.60">
                    Total
                </Typography>
              </StyledTableCell>
              <StyledTableCell sx={{ backgroundColor: "background.paper" }}/>
              <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                <Typography variant="h2" color="black_solid.80">
                  {formatCurrency(totalSum, 2)}
                </Typography>
              </StyledTableCell>
              <StyledTableCell sx={{ backgroundColor: "background.paper" }}/>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

SubmittedComchecksTable.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  stagedComchecksArray: PropTypes.array.isRequired,
  setStagedComchecksArray: PropTypes.func.isRequired,
  setComcheckToEdit: PropTypes.func,
  setStep: PropTypes.func,
  handleDeleteStagedComcheck: PropTypes.func
};